module.exports = __webpack_public_path__ + "static/img/gongzuoxiaoxi.894ec3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gongzuoxiaoxi.png
// module id = ScJN
// module chunks = 1